<div class="busy-overlay-parent" [ngClass]="isLoading||!appState.isReady?'disabled':''">
  <div *ngIf="isLoading||!appState.isReady" class="font-weight-bold busy-overlay"
  style="align-items: flex-start; padding-top: 100px;">
    <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
  </div>
  <ng-template fesListView
      #fesListView
      let-filteredTasks
      [fesListViewOf]="tasks"
      let-filteredTasks$="filtered$"
      (filtered)="onFiltered($event)"
      (sorted)="onSorted($event)"
      >
    <div>
      <div class="d-flex flex-row justify-content-between font-italic text-secondary align-items-center">
        <div class="px-1">
        <ng-container *ngIf="filteredTasks.length < tasks.length">
          {{filteredTasks.length}} of
        </ng-container>
        {{tasks.length}} tasks<ng-container *ngIf="filteredTasks.length > pageSize">, page {{page}} of {{totalPages}}</ng-container>
        </div>
        <div class="d-flex flex-row justify-content-end align-items-center">
          <select title="Page Size" class="custom-select ml-1" style="max-width:fit-content;font-size:smaller;" [ngModel]="pageSize"
          (change)="onPageSizeChange($event)"
          >
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="1000">1000</option>
            <option value="2000">2000</option>
          </select>
          <pagination *ngIf="bTabSelected && pageableTasks.length > pageSize"
            class="ml-1 my-auto"
            [itemsPerPage]="pageSize"
            [totalItems]="pageableTasks.length"
            [maxSize]="5"
            [boundaryLinks]="true"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
            firstText="&laquo;"
            lastText="&raquo;"
            [(ngModel)]="page"
            (numPages)="onNumPagesChanged($event)"
            (pageChanged)="onPageNumberChanged($event)"
          ></pagination>
        </div>
      </div>
    <app-task-calendar *ngIf="bShowCalendar"
      [taskKey]="calendarColumnName"
      [tasks$]="filteredTasks$"
      [taskUpdated$]="taskUpdated$"
      [userNamesById]="userNames"
      [buildingNamesById]="buildingNames"
      [routeNamesByid]="routeNames"
      [dateFilter]="calendarDateFilter"
      (dateFilterChanged)="onDateFilterChanged($event)"
      (editTask)="editTask($event)"
      (closeCalendar)="closeCalendar($event)"
      [viewActive]="bTabSelected">
    </app-task-calendar>
    <table class="task-table table table-striped table-bordered table-sm mb-0">
      <thead>
        <tr>
          <th class="align-top">
            <div class="d-flex flex-row">
              <div fesSortField="row.schedule.scheduledDate"
                sort="desc" default>
                Date
              </div>
              <div role="button" (click)="toggleShowCalendar('scheduledDate')">
                <i class="fa fa-calendar"
                  [ngStyle]="bShowCalendar&&calendarColumnName=='scheduledDate'&&{'color':'gold'}"
                ></i>
              </div>
            </div>
          </th>
          <th fesSortField="row.stage">Stage</th>
          <!--<th fesSortField="row.type">Type</th>-->
          <th fesSortField="row.routeId" *ngIf="bViewDrives">Route</th>
          <th fesSortField="routeName" [valueResolver]="routeNameResolver" *ngIf="bViewDrives">Route Name</th>
          <th fesSortField="row.buildingId" *ngIf="bViewTests || bViewScouts">Building</th>
          <th fesSortField="groupingfield" *ngIf="bViewTests">Group</th>
          <th fesSortField="buildingName" [valueResolver]="buildingNameResolver" *ngIf="bViewTests || bViewScouts">Building Name</th>
          <th *ngIf="bViewTests" fesSortField="row.order" [sortType]="'numericArray'">Test Order</th>
          <th fesSortField="row.pathIds" *ngIf="bViewTests || bViewScouts">Path(s)</th>
          <th fesSortField="row.sortFloorNames" [sortType]="'stringArray'" *ngIf="bViewTests || bViewScouts">Floor(s)</th>
          <th *ngIf="bViewTests || bViewDrives" fesSortField="row.cycle" [sortType]="'numeric'">Cycle</th>
          <th *ngIf="roleMgr.canEditUsers" fesSortField="row.assignedUserId"
              [valueResolver]="assignedUserNameResolver">Assigned To</th>
          <th class="align-top">
            <div class="d-flex flex-row">
              <div fesSortField="row.modifiedDate">Modified (Local)</div>
              <div role="button" (click)="toggleShowCalendar('modifiedDate')">
                <i class="fa fa-calendar"
                [ngStyle]="bShowCalendar&&calendarColumnName=='modifiedDate'&&{'color':'gold'}"></i>
              </div>
            </div>
          </th>
          <th *ngIf="bViewTests || bViewScouts" fesSortField="row.statusName">Status</th>
          <th style="text-align: center">
            <div *ngIf="roleMgr.isAdmin||roleMgr.canAssignScheduler||roleMgr.canSchedule" dropdown class="btn-group" placement="bottom right">
              <button dropdownToggle
                class="btn btn-secondary add-btn dropdown-toggle" aria-controls="dropdown-add-task">
                Add
              </button>
              <ul id="dropdown-add-task" *dropdownMenu role="menu"
                class="p-2 dropdown-menu dropdown-menu-right" style="min-width: 5rem;">
                <li *ngIf="bViewTests" role="menuitem" style="margin-bottom:2px;">
                    <button class="btn btn-secondary w-100 text-left text-nowrap" style="border-radius:0;"
                            [disabled]="!roleMgr.canEditPointTests"
                            (click)="editPathTest(pathTestService.rxCollection.newDocument())">
                        <i class="fa fa-plus-square mr-1"></i>
                        Path Test
                    </button>
                </li>
                <li *ngIf="bViewDrives" role="menuitem" style="margin-bottom:2px;">
                    <button class="btn btn-secondary w-100 text-left text-nowrap" style="border-radius:0;"
                            [disabled]="!roleMgr.canEditPointTests"
                            (click)="editPathTest(driveTestService.rxCollection.newDocument())">
                        <i class="fa fa-plus-square mr-1"></i>
                        Drives Test
                    </button>
                </li>
                <li *ngIf="bViewScouts" role="menuitem" style="margin-bottom:0;">
                    <button class="btn btn-secondary w-100 text-left text-nowrap" style="border-radius:0;"
                            [disabled]="!roleMgr.canEditPointTests" (click)="editScoutTaskModal(null)">
                        <i class="fa fa-plus-square mr-1"></i>
                        Scout
                    </button>
                </li>
              </ul>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <app-filter-field-config>
              <input fesFilterField="row.schedule.scheduledDate"
                size="12" [transformFn]="formatScheduledDate" [(value)]='filterObj.scheduledDate'
                [disabled]="bShowCalendar && calendarColumnName=='scheduledDate'"
              style="min-width:5em;"/>
            </app-filter-field-config>
          </td>
          <td>
            <app-filter-field-config>
              <input fesFilterField="row.stage" [(value)]='filterObj.stage' class="w-100" style="min-width:3.5em;"/>
            </app-filter-field-config>
          </td>
          <!--
          <td>
            <input fesFilterField="row.type" name="type" [(value)]='filterObj.type' (valueChange)="typeChanged$.emit($event)" class="w-100"/>
          </td>
          -->
          <td *ngIf="bViewDrives">
            <input fesFilterField="row.routeId" [(value)]='filterObj.routeId' class="w-100"/>
          </td>
          <td *ngIf="bViewDrives">
            <input fesFilterField="row.routeId" [valueResolver]="routeNameResolver" [(value)]='filterObj.market' class="w-100"/>
          </td>
          <td *ngIf="bViewTests || bViewScouts">
            <input fesFilterField="row.buildingId" [(value)]='filterObj.buildingId' class="w-100"/>
          </td>
          <td *ngIf="bViewTests">
            <app-filter-field-config>
              <input fesFilterField="groupingfield" [(value)]='filterObj.groupingfield' class="w-100"/>
            </app-filter-field-config>
          </td>
          <td *ngIf="bViewTests|| bViewScouts">
            <input fesFilterField="row.buildingId" [valueResolver]="buildingNameResolver" [(value)]='filterObj.buildingCommonName' class="w-100"/>
          </td>
          <td *ngIf="bViewTests">
            <input fesFilterField="row.order" size="2"/>
          </td>
          <td *ngIf="bViewTests || bViewScouts">
            <input fesFilterField="row.pathIds" class="w-100"/>
          </td>
          <td *ngIf="bViewTests|| bViewScouts">
            <input fesFilterField="row.floorNames" class="w-100"/>
          </td>
          <td *ngIf="bViewTests || bViewDrives">
            <input fesFilterField="row.cycle" size="2"/>
          </td>
          <td *ngIf="roleMgr.canEditUsers">
            <input fesFilterField="row.assignedUserId" [valueResolver]="assignedUserNameResolver" [(value)]='filterObj.assignedUserName' class="w-100"/>
          </td>
          <td>
            <app-filter-field-config>
              <input fesFilterField="row.modifiedDate"
              [(value)]='filterObj.modifiedDate'
              class="w-100"
              [valueResolver]="modifiedDateResolver"
              [disabled]="bShowCalendar && calendarColumnName=='modifiedDate'" />
            </app-filter-field-config>
          </td>
          <td *ngIf="bViewTests || bViewScouts">
            <input fesFilterField="row.statusName" [(value)]='filterObj.statusName' class="w-100"/>
          </td>
          <td></td>
        </tr>
        <!--pageableTasks|taskRange:(page-1)*pageSize:pageSize-->
        <tr *ngFor="let task of pageableTasks|taskRange:(page-1)*pageSize:pageSize" [ngClass]="selectedTask==task?'selected-task-row':''">
          <td class="text-center text-nowrap" title="{{task.row.schedule?.scheduledDate}} UTC ==> {{task.row.schedule?.scheduledDate|date:'yyyy-MM-dd HH:mm:ss ZZZZ'}}">
            {{task.row.schedule?.scheduledDate|date:'yyyy-MM-dd'}}
          </td>
          <td class="text-center">
            {{task.row.stage}}
          </td>
          <!--
          <td class="text-center" (dblclick)="dumpTaskToConsole(task)">{{task.row.type=='path test'?'Test':task.row.type|titlecase}}</td>
          -->
          <td *ngIf="bViewDrives"><a href="javascript:false" (click)="showRoute(task)">{{task.row.routeId}}</a></td>
          <td *ngIf="bViewDrives"><a href="javascript:false" (click)="showRoute(task)">{{routeNames[task.row.routeId]}}</a></td>
          <td *ngIf="bViewTests || bViewScouts"><a href="javascript:false" (click)="showBuilding(task)">{{task.row.buildingId}}</a></td>
          <td *ngIf="bViewTests">{{task.groupingfield}}</td>
          <td *ngIf="bViewTests || bViewScouts"><a href="javascript:false" (click)="showBuilding(task)">{{buildingNames[task.row.buildingId]}}</a></td>
          <td *ngIf="bViewTests" class="text-center">{{task.row.order || ''}}</td>
          <td *ngIf="bViewTests || bViewScouts">
            <ng-container *ngIf="task.row.type=='scout'; else notScoutTask">
              <a *ngFor="let idAndNumber of task.row.pathIdAndNumberArray; let isLastPathId=last;"
                href="javascript:false" (click)="showPath(task,idAndNumber['id'])">
                {{idAndNumber['pathNumber']||'?'}}{{isLastPathId?'':', '}}
              </a>
            </ng-container>
            <ng-template #notScoutTask>
              <a *ngFor="let pathId of task.row.pathIds; let isLastPathId=last;"
                href="javascript:false" (click)="showPath(task,pathId)">
                {{pathId}}{{isLastPathId?'':','}}
              </a>
            </ng-template>
          </td>
          <td class="text-center" *ngIf="bViewTests || bViewScouts">
            <ng-container *ngFor="let floor of task.row.floorNames; let isLast=last">
              {{floor}}{{isLast?'':','}}
            </ng-container>
          </td>
          <td *ngIf="bViewTests || bViewDrives" class="text-center">{{task.row.cycle}}</td>
          <td *ngIf="roleMgr.canEditUsers">
            <a  href="javascript:false;">{{userNames[task.row.assignedUserId]}}</a>
          </td>
          <td class="text-nowrap" >
            {{task.row.modifiedDate|date:'yyyy-MM-dd HH:mm:ss'}}
            <div class="small text-muted font-italic">
                {{userNames[task.row.modifiedByUserId]}}
                <br/>{{task.row['x']}}
            </div>
          </td>
          <ng-container [ngSwitch]="task.row.statusName" *ngIf="bViewTests || bViewScouts">
            <td *ngSwitchCase="'complete'" class="text-center align-middle status-complete" data-toggle="tooltip" title="complete">
              <i class='fa fa-check font-italic'></i>
            </td>
            <td *ngSwitchCase="'in progress'" class="text-center align-middle status-in-progress">In Progress</td>
            <td *ngSwitchCase="'not started'" class="text-center align-middle status-not-started">Not Started</td>
            <td *ngSwitchCase="'field complete'" class="text-center align-middle status-field-complete">Field Complete</td>
            <td *ngSwitchCase="'review complete'" class="text-center align-middle status-review-complete">Review Complete</td>
            <td *ngSwitchCase="'not using'" class="text-center align-middle status-not-using">Not Using</td>
            <td *ngSwitchDefault class="text-center align-middle">{{task.row.statusName}}</td>
          </ng-container>
          <td class="text-center align-middle">
            <a class="text-nowrap" href="javascript:false;" (click)="editTask(task)">edit</a>
          </td>
        </tr>
      </tbody>

    </table>
  </div>
  </ng-template>
</div>

<ng-template #editAssignedUserTemplate>
<div *ngIf="selectedTask">
  <div class="modal-header light-blue-header white">
    <div class="modal-title">
      <h5 *ngIf="bViewTests">{{selectedTask.type|titlecase}} - {{selectedTask.stage}} - {{selectedTask['taskBuildingId']}} - {{selectedTask.pathId}} - {{selectedTask.cycle}}</h5>
      <h5 *ngIf="bViewDrives">{{selectedTask.type|titlecase}} - {{selectedTask.stage}} - {{selectedTask['routeId']}} - {{selectedTask.cycle}}</h5>
    </div>
    <button type="button" class="close pull-right" aria-label="Close" (click)="selectedTask=null;editAssignedUserModal.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-striped table-condensed">
      <tbody>
      <tr>
        <th class="text-right">Assigned User:</th>
        <td>
          <select [(ngModel)]="selectedUser">
            <option *ngFor="let user of allUsers" [ngValue]="user">{{user.firstName + ' ' + user.lastName}}</option>
          </select>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer small">
    <button [disabled]="selectedUser&&selectedUser._id==selectedTask.assignedUserId" (click)="saveAssignedUser()" class="btn btn-primary">Save</button>
    <button (click)="selectedTask=null;editAssignedUserModal.hide()" class="btn btn-secondary">Cancel</button>
  </div>
</div>
</ng-template>